const cases = [{
  id: 'grey-leather',
  name_pre: '',
  name: 'Grey',
  name_post: 'Leather',
  price_from: 'CHF 250',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/case_grey-leather.jpg?v=1618390122',
  variantId: 39317549285533
}, {
  id: 'black-textile',
  name_pre: '',
  name: 'Black',
  name_post: 'Textile',
  price_from: 'CHF 200',
  production_cover: 'https://cdn.shopify.com/s/files/1/0305/1975/4884/files/case_black-textile.jpg?v=1618390122',
  variantId: 39317547843741
}]

export default cases;
